import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'labor-info',
  templateUrl: './labor-info.component.html',
  styleUrls: ['./labor-info.component.css']
})
export class LaborInfoComponent implements OnInit {
  @Input() labors;
  @Output() saveAllDataInfo: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  isArray(val) {
    return val.constructor === Array;
  }

  savePath(category, laborName): void {
    if (category != '') {
      laborName = category + '/' + laborName;
    }
    this.saveAllDataInfo.emit(laborName);
  }

  ngOnInit() {

  }

}
